import { Space, Typography } from 'antd'
import KDateInfo from 'app/components/Modules/DataDisplay/KDateInfo'
import KItem from 'app/components/Modules/General/KItem'
import * as React from 'react'

import { MemberProps } from '../../convention'
import ProjectStageTag from '../StageTag'

type Props = {
  extra?: React.ReactNode
  description?: React.ReactNode
}

const ProjectItem: React.FC<MemberProps<IProject, Props>> = ({ member, props = {} }) => {
  return (
    <KItem
      title={
        <Typography.Title level={4} className="text-black text-base">
          {member.name || '-'}
        </Typography.Title>
      }
      extra={<ProjectStageTag member={member} />}
      description={
        <Space direction="vertical">
          {member.city && <span>{member.city}</span>}
          <KDateInfo dates={{ start_date: member.start_date, return_date: member.end_date }} />
        </Space>
      }
      {...props}
    />
  )
}

export default ProjectItem
